import { NgModule } from "@angular/core";
import { GridPipe } from "./gridPipe";

@NgModule({
	declarations: [GridPipe],
	exports: [GridPipe],
})
export class GridPipeModule {}
